module.exports = __webpack_public_path__ + "static/media/bocce_beats1.269fa016.png";